import BaseModel from './baseModel';

class CertReqUniqueNoModel extends BaseModel {
  // constructor(refs) {
  //   super(refs);
  //   this.Id;
  //   this.Title;
  //   this.Abstract;
  //   this.SelectedTags;
  //   this.Tags;
  //   this.Images;
  //   this.SelectedImages;
  // }
}

export default CertReqUniqueNoModel;